import MobileNav from "./MobileNav"
import { Usedata } from "./Context/Allcontext";
import { UseAuth } from "./AuthContext/AuthContext";
import {Link} from "react-router-dom"
import { useState } from "react";
function Nav(){
    const {ActivLogin, ActiveNavmobile , navmobile} = Usedata()
    const {Logout , crentuser}  = UseAuth()
    const [scroll,setscroll] = useState(0)
    //const email = crentuser && crentuser.email

    window.onscroll = function(){
        setscroll(window.scrollY)
    }

    const LogoutHandale = async () => {
        try{
            await Logout()
        } catch (error) {
            console.log(error)
        }
    }

    const  HomeHandale = () => {
        window.scrollTo({
            top :0,
            behavior:"smooth"
        }) 
    }

    const  QiimahaHandale = () => {
        window.scrollTo({
            top :591,
            behavior:"smooth"
        }) 

    }

    const  DhaqdhaqaaqHandale = () => {
        window.scrollTo({
            top :1895,
            behavior:"smooth"
        }) 

    }

    return(
        <div className={scroll >= 80 ? "over_nav hoos" :"over_nav"}>
        <div className="haye">
            <nav className="nav">
                <div className="logo">
                    <Link to="/">
                    <img src="/images/logo.png" alt="sawir logo" />
                    </Link>
                </div>
                <div className="nav_links">
                    <ul className="links">
                        <li onClick={HomeHandale}>
                            <Link to="/">
                                Home
                            </Link>
                        </li>
                        <li onClick={QiimahaHandale}>
                            <a href="#Qiimayaal">
                                Qiimaha Dahabka
                            </a>
                        </li>
                        <li onClick={DhaqdhaqaaqHandale}>
                            <a href="#transc">
                                Dhaqdhaqaaq
                            </a>
                        </li>
                        {/* {crentuser && crentuser ?
                            <li onClick={DhaqdhaqaaqHandale}>
                                <a href="#transc">
                                    {email}
                                </a>
                            </li>
                            :
                            <>
                            </>
                        } */}

                    </ul>
                </div>
                <div className="pars_moblibe" onClick={ActiveNavmobile}>
                    <i className="fa-solid fa-bars"></i>
                </div>
                {crentuser && crentuser ?
                    <button onClick={LogoutHandale}>Xidho <i className="fa-solid fa-arrow-right-to-bracket"></i></button>
                : <button onClick={ActivLogin}>Gal <i className="fa-solid fa-arrow-right-to-bracket"></i></button>
                }
                
               
            </nav>
        </div>
        <MobileNav nav={navmobile}/>
    </div>
    )
}


export default Nav